import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ViewMode } from "src/app/shared/enums/view-mode.enum";
import { SinglePermissionModel } from "../shared/models/IPermission";
import { PermissionLobby } from "../shared/models/lobby.permission.model";
import { PermissionsServiceService } from "../shared/services/permissions-service.service";
import { TranslationLoaderFacade } from "../../localization/translation-loader.facade";
import {
  getViewModleForPermissions,
  setSelectAllLobbyStatus,
} from "./permissions-lobby.mapper";

@Component({
  selector: "app-permissions-lobby",
  templateUrl: "./permissions-lobby.component.html",
  styleUrls: ["./permissions-lobby.component.scss"],
})
export class PermissionsLobbyComponent implements OnInit {
  @Output() dirtyEmitter = new EventEmitter<boolean>(false);
  private _allPermissionInCategory: { data: any[]; groupPermission: number[] } =
    { data: [], groupPermission: [] };
  @Input() set allPermissionsInCategory(value: {
    data: any[];
    groupPermission: number[];
  }) {
    this._allPermissionInCategory = value;
    this.updatModlesFromBackEnd(this._allPermissionInCategory?.data ?? []);
  }
  isLoaded: boolean = false;

  @Output() LobbyObject: EventEmitter<PermissionLobby> =
    new EventEmitter<PermissionLobby>();
  public permissionLobby: PermissionLobby = new PermissionLobby();
  public initialPermissionLobbyState: PermissionLobby = new PermissionLobby();
  @Input() isViewOnly: boolean = false;
  @Input() isUkgDefaultGroup: boolean = false;
  @Output() sectionSelectAll: EventEmitter<boolean> = new EventEmitter<boolean>(
    false
  );
  public disabledSelectAllLobby: boolean = true;

  constructor(
    public permissionService: PermissionsServiceService,
    private translationLoaderFacade: TranslationLoaderFacade
  ) {}

  ngOnInit(): void {
  }

  ngOnDestroy() {
    this.permissionLobby = new PermissionLobby();
  }

  private updatModlesFromBackEnd(model: SinglePermissionModel[]) {
    this.permissionService
      .getEdittingPermissionCategory()
      .subscribe((isEditting) => {
        if (isEditting) {
          this.setedditingParams(model, isEditting.viewMode);
        } else {
          this.setAddParams(model);
        }
        this.initialPermissionLobbyState = JSON.parse(
          JSON.stringify(this.permissionLobby)
        );
        this.publishUpdatedObject(false);
      });
  }

  checkSelectAllPermission(isSelectAllEnabled: boolean) {
    if (isSelectAllEnabled) {
      this.changeSelectAllLobby();
    } else {
      this.permissionLobby.selectAllPermissionLobby.Selected = false;
      this.sectionSelectAll.emit(false);
    }
  }

  onTextConfigurationItemChange() {
    this.permissionLobby.TextConfiguration.selectAll =
      this.permissionLobby.TextConfiguration.textConfigView.Selected &&
      this.permissionLobby.TextConfiguration.textConfigEdit.Selected &&
      this.permissionLobby.TextConfiguration.textConfigEnable.Selected;
    this.changeSelectAllLobby();
    this.handleTextConfigurationChildElements();
    this.publishUpdatedObject();
  }
  handleTextConfigurationChildElements() {
    const textMsg = this.permissionLobby.TextConfiguration;
    if (!textMsg.textConfigView.Selected) {
      textMsg.textConfigEdit.Selected = false;
    }
  }
  selectAllTextConfiguration() {
    this.permissionLobby.TextConfiguration.textConfigView.Selected =
      this.permissionLobby.TextConfiguration.textConfigView.Selected &&
      !this.permissionLobby.TextConfiguration.textConfigView.Enabled
        ? true
        : this.permissionLobby.TextConfiguration.selectAll &&
          this.permissionLobby.TextConfiguration.textConfigView.Enabled;
    this.permissionLobby.TextConfiguration.textConfigEdit.Selected =
      this.permissionLobby.TextConfiguration.textConfigEdit.Selected &&
      !this.permissionLobby.TextConfiguration.textConfigEdit.Enabled
        ? true
        : this.permissionLobby.TextConfiguration.selectAll &&
          this.permissionLobby.TextConfiguration.textConfigEdit.Enabled;
    this.permissionLobby.TextConfiguration.textConfigEnable.Selected =
      this.permissionLobby.TextConfiguration.textConfigEnable.Selected &&
      !this.permissionLobby.TextConfiguration.textConfigEnable.Enabled
        ? true
        : this.permissionLobby.TextConfiguration.selectAll &&
          this.permissionLobby.TextConfiguration.textConfigEnable.Enabled;
    this.checkSelectAllPermission(
      this.permissionLobby.TextConfiguration.selectAll
    );
    this.publishUpdatedObject();
  }

  onLwaItemChange() {
    this.permissionLobby.Lwa.selectAll =
      this.permissionLobby.Lwa.lwaView.Selected &&
      this.permissionLobby.Lwa.lwaAdd.Selected &&
      this.permissionLobby.Lwa.lwaEdit.Selected &&
      this.permissionLobby.Lwa.lwaDelete.Selected;
    this.changeSelectAllLobby();
    this.handleLwaChildElements();
    this.publishUpdatedObject();
  }
  handleLwaChildElements() {
    const lwa = this.permissionLobby.Lwa;
    if (!lwa.lwaView.Selected) {
      lwa.lwaAdd.Selected = false;
      lwa.lwaEdit.Selected = false;
      lwa.lwaDelete.Selected = false;
    }
  }

  selectAllLwa() {
    this.permissionLobby.Lwa.lwaView.Selected =
      this.permissionLobby.Lwa.lwaView.Selected &&
      !this.permissionLobby.Lwa.lwaView.Enabled
        ? true
        : this.permissionLobby.Lwa.selectAll &&
          this.permissionLobby.Lwa.lwaView.Enabled;
    this.permissionLobby.Lwa.lwaAdd.Selected =
      this.permissionLobby.Lwa.lwaAdd.Selected &&
      !this.permissionLobby.Lwa.lwaAdd.Enabled
        ? true
        : this.permissionLobby.Lwa.selectAll &&
          this.permissionLobby.Lwa.lwaAdd.Enabled;
    this.permissionLobby.Lwa.lwaEdit.Selected =
      this.permissionLobby.Lwa.lwaEdit.Selected &&
      !this.permissionLobby.Lwa.lwaEdit.Enabled
        ? true
        : this.permissionLobby.Lwa.selectAll &&
          this.permissionLobby.Lwa.lwaEdit.Enabled;
    this.permissionLobby.Lwa.lwaDelete.Selected =
      this.permissionLobby.Lwa.lwaDelete.Selected &&
      !this.permissionLobby.Lwa.lwaDelete.Enabled
        ? true
        : this.permissionLobby.Lwa.selectAll &&
          this.permissionLobby.Lwa.lwaDelete.Enabled;
    this.checkSelectAllPermission(this.permissionLobby.Lwa.selectAll);
    this.publishUpdatedObject();
  }

  onChecklistItemChange() {
    this.permissionLobby.Checklist.selectAll =
      this.permissionLobby.Checklist.viewChecklist.Selected &&
      this.permissionLobby.Checklist.addChecklist.Selected &&
      this.permissionLobby.Checklist.editCheckList.Selected &&
      this.permissionLobby.Checklist.deleteChecklist.Selected;

    this.changeSelectAllLobby();
    this.handleChecklistChildElements();
    this.publishUpdatedObject();
  }
  handleChecklistChildElements() {
    const checkList = this.permissionLobby.Checklist;
    if (!checkList.viewChecklist.Selected) {
      checkList.addChecklist.Selected = false;
      checkList.editCheckList.Selected = false;
      checkList.deleteChecklist.Selected = false;
    }
  }

  selectAllChecklist() {
    this.permissionLobby.Checklist.viewChecklist.Selected =
      this.permissionLobby.Checklist.viewChecklist.Selected &&
      !this.permissionLobby.Checklist.viewChecklist.Enabled
        ? true
        : this.permissionLobby.Checklist.selectAll &&
          this.permissionLobby.Checklist.viewChecklist.Enabled;
    this.permissionLobby.Checklist.addChecklist.Selected =
      this.permissionLobby.Checklist.addChecklist.Selected &&
      !this.permissionLobby.Checklist.addChecklist.Enabled
        ? true
        : this.permissionLobby.Checklist.selectAll &&
          this.permissionLobby.Checklist.addChecklist.Enabled;
    this.permissionLobby.Checklist.editCheckList.Selected =
      this.permissionLobby.Checklist.editCheckList.Selected &&
      !this.permissionLobby.Checklist.editCheckList.Enabled
        ? true
        : this.permissionLobby.Checklist.selectAll &&
          this.permissionLobby.Checklist.editCheckList.Enabled;
    this.permissionLobby.Checklist.deleteChecklist.Selected =
      this.permissionLobby.Checklist.deleteChecklist.Selected &&
      !this.permissionLobby.Checklist.deleteChecklist.Enabled
        ? true
        : this.permissionLobby.Checklist.selectAll &&
          this.permissionLobby.Checklist.deleteChecklist.Enabled;
    this.checkSelectAllPermission(this.permissionLobby.Checklist.selectAll);
    this.publishUpdatedObject();
  }

  onLobbyItemChange() {
    this.permissionLobby.General.selectAll =
      this.permissionLobby.General.editLobby.Selected &&
      this.permissionLobby.General.viewCentralViews.Selected &&
      this.permissionLobby.General.forceSignOutUsers.Selected &&
      this.permissionLobby.General.accessAllQueues.Selected;
    this.changeSelectAllLobby();
    this.publishUpdatedObject();
  }

  selectAllLobby() {
    this.permissionLobby.General.editLobby.Selected =
      this.permissionLobby.General.editLobby.Selected &&
      !this.permissionLobby.General.editLobby.Enabled
        ? true
        : this.permissionLobby.General.selectAll &&
          this.permissionLobby.General.editLobby.Enabled;
    this.permissionLobby.General.viewCentralViews.Selected =
      this.permissionLobby.General.viewCentralViews.Selected &&
      !this.permissionLobby.General.viewCentralViews.Enabled
        ? true
        : this.permissionLobby.General.selectAll &&
          this.permissionLobby.General.viewCentralViews.Enabled;
    this.permissionLobby.General.forceSignOutUsers.Selected =
      this.permissionLobby.General.forceSignOutUsers.Selected &&
      !this.permissionLobby.General.forceSignOutUsers.Enabled
        ? true
        : this.permissionLobby.General.selectAll &&
          this.permissionLobby.General.forceSignOutUsers.Enabled;
    this.permissionLobby.General.accessAllQueues.Selected =
      this.permissionLobby.General.accessAllQueues.Selected &&
      !this.permissionLobby.General.accessAllQueues.Enabled
        ? true
        : this.permissionLobby.General.selectAll &&
          this.permissionLobby.General.accessAllQueues.Enabled;
    this.checkSelectAllPermission(this.permissionLobby.General.selectAll);
    this.publishUpdatedObject();
  }

  public publishUpdatedObject(emitDirty: boolean = true) {
    if (
      emitDirty &&
      JSON.stringify(this.permissionLobby) !==
        JSON.stringify(this.initialPermissionLobbyState)
    ) {
      this.dirtyEmitter.emit(true);
    } else {
      this.dirtyEmitter.emit(false);
    }
    this.LobbyObject.emit(this.permissionLobby);
  }

  setedditingParams(model: SinglePermissionModel[], viewMode: number) {
    this.permissionLobby = getViewModleForPermissions(
      model,
      viewMode,
      this._allPermissionInCategory.groupPermission
    );
    //this.permissionLobby = getViewModleForPermissions(model, true, viewMode);
    this.disabledSelectAllLobby = setSelectAllLobbyStatus(this.permissionLobby);
    if (model.length > 0) {
      this.isLoaded = true;
    }
  }

  setAddParams(model: SinglePermissionModel[]) {
    this.permissionLobby = getViewModleForPermissions(model, ViewMode.Add);
    this.disabledSelectAllLobby = setSelectAllLobbyStatus(this.permissionLobby);
    if (model.length > 0) {
      this.isLoaded = true;
    }
  }

  valueChangeByselectAllPermissionsLobby(e: Event) {
    const target = e.target as HTMLInputElement;
    this.valueChangeByselectAllPermissionsLobbyCommon(target.checked);
    this.sectionSelectAll.emit(target.checked);
  }

  valueChangeByselectAllPermissionsLobbyCommon(isEnable: boolean) {
    if (
      this.permissionLobby.General.editLobby.Enabled &&
      this.permissionLobby.General.forceSignOutUsers.Enabled &&
      this.permissionLobby.General.viewCentralViews.Enabled &&
      this.permissionLobby.General.accessAllQueues.Enabled
    )
      this.permissionLobby.General.selectAll = isEnable;

    if (
      this.permissionLobby.Checklist.addChecklist.Enabled &&
      this.permissionLobby.Checklist.deleteChecklist.Enabled &&
      this.permissionLobby.Checklist.editCheckList.Enabled &&
      this.permissionLobby.Checklist.viewChecklist.Enabled
    )
      this.permissionLobby.Checklist.selectAll = isEnable;

    if (
      this.permissionLobby.Lwa.lwaAdd.Enabled &&
      this.permissionLobby.Lwa.lwaDelete.Enabled &&
      this.permissionLobby.Lwa.lwaEdit.Enabled &&
      this.permissionLobby.Lwa.lwaView.Enabled
    )
      this.permissionLobby.Lwa.selectAll = isEnable;

    if (
      this.permissionLobby.TextConfiguration.textConfigEdit.Enabled &&
      this.permissionLobby.TextConfiguration.textConfigEnable.Enabled &&
      this.permissionLobby.TextConfiguration.textConfigView.Enabled
    )
      this.permissionLobby.TextConfiguration.selectAll = isEnable;

    this.selectAllChecklist();
    this.selectAllLobby();
    this.selectAllLwa();
    this.selectAllTextConfiguration();
  }

  changeSelectAllLobby() {
    this.permissionLobby.selectAllPermissionLobby.Selected =
      this.permissionLobby.General.selectAll == true &&
      this.permissionLobby.Checklist.selectAll == true &&
      this.permissionLobby.Lwa.selectAll == true &&
      this.permissionLobby.TextConfiguration.selectAll == true;

    this.sectionSelectAll.emit(
      this.permissionLobby.selectAllPermissionLobby.Selected
    );
  }
}
